function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6608 6.97614C12.2432 7.11533 9.35509 11.8477 3.26569 14.4574C1.69984 15.3274 1.00391 16.8932 1.35189 21.7647C1.62462 25.5826 5.70147 26.8102 6.3974 26.8102C6.95415 26.8102 32.0309 26.5782 44.4997 26.4623C45.6016 26.5202 47.2486 25.5575 47.8053 24.7224C48.8492 23.1566 49.0232 21.2428 48.6753 19.155C48.3969 17.4847 46.0075 15.5013 44.8476 15.1534C39.8021 14.2834 38.7582 14.4574 37.5403 13.4135C36.0458 12.1325 29.9242 7.20336 29.0152 6.97614C27.6233 6.6282 13.1827 6.80216 12.6608 6.97614ZM12.6608 6.97614C11.2689 6.04824 8.17201 4.01845 6.91933 3.32252C5.35348 2.45261 3.78763 0.190829 1.00391 1.93066",
  stroke: "#373D49",
  strokeWidth: 1.70117,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0105 9.93384L13.8788 14.9793H21.708",
  stroke: "#373D49",
  strokeWidth: 1.70117,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 25.3613,
  y: 17.5891,
  width: 4.87152,
  height: 1.0439,
  rx: 0.52195,
  fill: "#373D49"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.5729,
  cy: 25.7664,
  r: 4.69754,
  fill: "#373D49"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 35.9744,
  cy: 25.7664,
  rx: 4.69754,
  ry: 4.69754,
  fill: "#373D49"
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 10.5729,
  cy: 25.7662,
  rx: 3.30568,
  ry: 3.30568,
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 35.9743,
  cy: 25.7662,
  rx: 3.30568,
  ry: 3.30568,
  fill: "white"
});

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 31,
    viewBox: "0 0 50 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.3c4d37f1.svg";
export { ForwardRef as ReactComponent };